import ERP from "../ERP.mjs";
import Schema from "../Schema.mjs";
import UtilDateTime from "@/utils/UtilDateTime";

export default {

    async criarContaAReceberAdiantamento(jobParcelaAdiantamentoValores = {}){

        let jobParcelaAdiantamento;

        try{

            //==================================================================//
            //================== Pega Job Parcela Adiantamento =================//
            //==================================================================//

            let jobParcelaAdiantamentoID = jobParcelaAdiantamentoValores?.id;

            jobParcelaAdiantamento = await ERP.getOneById(Schema.JOB_PARCELAS, jobParcelaAdiantamentoID);
            if(jobParcelaAdiantamento.status != 200){
                throw jobParcelaAdiantamento;
            }

            console.log(jobParcelaAdiantamento);

            //==================================================================//
            //============================ Pega Job ============================//
            //==================================================================//

            let jobID = jobParcelaAdiantamento?.data?.job;

            let job = await ERP.getOneById(Schema.JOB, jobID);
            if(job.status != 200){
                throw job;
            }

            //==================================================================//
            //=============== Cria Conta a Receber Adiantamento ================//
            //==================================================================//

            let contaAReceberAdiantamentoValores = {
                origem: "Conta a Receber Avulsa",
                status: "Prevista",
                descricao: `Adiantamento`,
                parcela: 1,
                job: jobID,
                jobParcela: jobParcelaAdiantamentoID,
                cliente: job?.data?.cliente,
                contaFinanceira: jobParcelaAdiantamentoValores?.contaFinanceira,
                valorOriginal: jobParcelaAdiantamentoValores?.valorOriginal,
                valorRecebido: 0,
                valorSaldo: jobParcelaAdiantamentoValores?.valorOriginal,
                dataCriacao: UtilDateTime.todayUTC(),
                dataVencimento: UtilDateTime.toFormatUTC({dateTime:jobParcelaAdiantamento?.data?.dataVencimento}),
            };

            let contaAReceberAdiantamento = await ERP.postOne(Schema.CONTAS_A_RECEBER, contaAReceberAdiantamentoValores);
            if(contaAReceberAdiantamento.status != 200){
                throw contaAReceberAdiantamento;
            }

            console.log(contaAReceberAdiantamento);

            //==================================================================//
            //============== Altera o Job Parcela Adiantamento =================//
            //==================================================================//

            let valorRecebido = jobParcelaAdiantamento?.data?.valorRecebido + contaAReceberAdiantamento?.data?.valorOriginal;
            let valorParaReceber = jobParcelaAdiantamento?.data?.valorParaReceber - contaAReceberAdiantamento?.data?.valorOriginal;

            jobParcelaAdiantamentoValores = {
                id: jobParcelaAdiantamentoID,
                valorRecebido: valorRecebido,
                valorParaReceber: valorParaReceber,
            }

            jobParcelaAdiantamento = await ERP.patchOne(Schema.JOB_PARCELAS, jobParcelaAdiantamentoValores);
            if(jobParcelaAdiantamento.status != 200){
                throw jobParcelaAdiantamento;
            }

            //==================================================================//
            //================ Cria um Movimento Financeiro ====================//
            //==================================================================//

            let movimentoFinanceiroValores = {
                descricao: `Gerado pela Conta a Receber de Adiantamento ${contaAReceberAdiantamento?.data?.codigo}`,
                dataMovimento: UtilDateTime.todayUTC(),
                valorMovimento: contaAReceberAdiantamento?.data?.valorOriginal,
                contaFinanceira: contaAReceberAdiantamento?.data?.contaFinanceira,
                contaAReceber: contaAReceberAdiantamento?.data?.id,
                cliente: contaAReceberAdiantamento?.data?.cliente,
                //Futuramente adicionar o Job e implementar essa melhoria aqui.
            }

            let movimentoFinanceiro = await ERP.postOne(Schema.MOVIMENTO_FINANCEIRO, movimentoFinanceiroValores);
            if(movimentoFinanceiro.status != 200){
                throw movimentoFinanceiro;
            }

            console.log(movimentoFinanceiro);

            //==================================================================//
            //=================== Pega a Conta Financeira ======================//
            //==================================================================//

            let contaFinanceira = await ERP.getOneById(Schema.CONTAS_FINANCEIRAS, contaAReceberAdiantamento?.data?.contaFinanceira);
            if(contaFinanceira.status != 200){
                throw contaFinanceira;
            }

            //==================================================================//
            //================= Altera a Conta Financeira ======================//
            //==================================================================//

            let contaFinanceiraNovoSaldo = contaFinanceira?.data?.saldo + contaAReceberAdiantamento?.data?.valorOriginal;

            let contaFinanceiraValores = {
                id: contaAReceberAdiantamento?.data?.contaFinanceira,
                saldo: contaFinanceiraNovoSaldo
            }

            contaFinanceira = await ERP.patchOne(Schema.CONTAS_FINANCEIRAS, contaFinanceiraValores);
            if(contaFinanceira.status != 200){
                throw contaFinanceira;
            }

        }catch(e){

            console.log(e);
            return jobParcelaAdiantamento;

        }

        return jobParcelaAdiantamento;

    },

}